import { ProfileModel } from 'src/models/ProfileModel';
import { ProfileAdapterInteface } from 'src/adapter/ProfileAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export class ProfileApiClass {
  adapter: ProfileAdapterInteface;
  constructor(adapter: ProfileAdapterInteface) {
    this.adapter = adapter;
  }
  async getProfile(): Promise<ProfileModel> {
    try {
      const profile = await this.adapter.getProfile();
      return new ProfileModel(profile);
    } catch (e: any) {
      throw apiErrorHandler(e);
    }
  }
}
